__turbopack_context__.v({
  "container": "-mcHta_container",
  "firstRowWrapper": "-mcHta_firstRowWrapper",
  "footerColumns": "-mcHta_footerColumns",
  "footerCopyText": "-mcHta_footerCopyText",
  "footerMenuWrapper": "-mcHta_footerMenuWrapper",
  "footerTitle": "-mcHta_footerTitle",
  "footerTitleWrapper": "-mcHta_footerTitleWrapper",
  "footerVerticlaLine": "-mcHta_footerVerticlaLine",
  "socialWrapper": "-mcHta_socialWrapper",
});
